import React from "react";
import ReactDOM from "react-dom";
import { AGENTS, TEAM } from "../../consts/tables";
import { AGENTS_LIST_COUNT } from "../../consts/queries";
import AgentInfo from "./AgentInfo";
import AgentDuplicateModal from "./AgentDuplicateModal";
import { browserHistory } from "react-router";
import CRUD from "../CRUD/CRUD";
import { getCurrentAccess } from "../../access";
import { editsEverySummitRecord } from "../../access-levels";
import { getData, manageData } from "../../requests/CRUD";
import { createAgent, updateAgent, DUPLICATE_AGENT } from "../../requests/agents";
import LinkedFirm, { LinkedFirmEdits } from "../LinkedFirm";
import request from 'arcdynamic-request';
import { executeQuery } from "../../requests/executeQuery";

const limit = 1000;

/** The row with HSC_HOT_LIST set: whether the signed-in member follows this agent. */
function withHotList(row, email) {
  const followUpList = row['HSC_FOLLOW_UP'] ? row['HSC_FOLLOW_UP'].split(',') : [];
  return { ...row, HSC_HOT_LIST: followUpList.includes(email.toString()) ? '1' : '0' };
}

export default class CRUDAgent extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      data: null,
      original: null,
      isBusy: null,
      error: null,
      success: null,
      duplicates: null,
      duplicateMessage: null,
      errorTabs: [],
      currentTab: 0,
      viewMode: this.props.edit || false,
      hscAgentsData:[],
      loggedInUserData:{},
      firm: null,
      firmOriginal: null,
    };

    this.firmEdits = new LinkedFirmEdits(this, 'FIRM');

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChangeInput = this.handleChangeInput.bind(this);
    this.handleChangeDropdown = this.handleChangeDropdown.bind(this);
    this.saveData = this.saveData.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.params.id !== nextProps.params.id) {
      this.fetch(nextProps.params.id);
    }
  }

  componentDidMount() {
    this.setState({loggedInUserData: this.props.userData});
    this.fetch(this.props.params.id);
  }

  componentDidUpdate() {
    this.firmEdits.follow();
  }

  fetch(id) {
    const loggedInUserData = this.props.userData;
    this.setState({
      data: null,
      error: null,
      success: null,
    });


    getData({
      tableCode: TEAM,
      options: {
        limit: {
          "count": 1000,
          "offset": 0
        },
        column: [
          "ARCIMEDES_ROW_ID",
          "FIRST_NAME",
          "LAST_NAME",
          "DELETED",
          "IS_AGENT",
          "EMAIL"
        ],
      }
    }).then((res) => {
      if (res && res.success && Array.isArray(res.data) && res.data.length) {
        const hscAgentsData = res.data.filter(({ EMAIL }) => EMAIL && EMAIL.toLowerCase().includes('highstcapital'));
        this.setState({ hscAgentsData })
      }
    })

    if (id === undefined) {
      this.setState({ data: {} });
      return;
    }

    getData({
      tableCode: AGENTS,
      options: {
        filter: [
          {
            text: id,
            code: "ARCIMEDES_ROW_ID",
            type: "exact",
          },
        ],
      },
    }).then((res) => {
      if (res && res.success && Array.isArray(res.data) && res.data.length) {
       const row = withHotList(res.data[0], loggedInUserData.email);

       this.setState({
          data: row,
          original: { ...row },
          error: null,
        });
      } else {
        this.setState({
          data: false,
          error: res.message ? res.message : "Unidentified Error",
        });
      }
    });

    
  }

  async handleSubmit(e) {
    e.preventDefault();

    if (this.state.viewMode) this.setState({ viewMode: false });

    if (
      this.state.isBusy ||
      this.state.data.FIRST_NAME === "" ||
      this.state.data.LAST_NAME === "" ||
      this.state.viewMode === true
    ){
      return;
    }
    else {     
      this.setState({ viewMode: true }, () => this.saveData());
    }
  }

  handleChangeInput (key, value)  {
    this.setState((prevState) => {
        let newValue;

        if (key === "HSC_HOT_LIST") {
            newValue = prevState.data[key] === "1" ? "0" : "1"; // Toggle between "1" and "0"
        } else {
            newValue = value;
        }

        return {
            data: {
                ...prevState.data,
                [key]: newValue,
                
            }
        };
    });
  }

  
  /* handleChangeInput(key, value) {   
    this.setState({
      data: Object.assign(this.state.data, {
        [key]: value,
      }),
    });
  } */
  saveData() {
    if (this.state.isBusy) return;

    return this.firmEdits.saveThen(() => this.saveAgent());
  }

    saveAgent(force = false) {
      if (this.state.isBusy) return;
  
      const newData = { ...this.state.data };
  
      //const loggedInUserId = this.state.loggedInUserData.id;
      const loggedInUserEmail = this.state.loggedInUserData.email;

      if (newData["HSC_HOT_LIST"] === "1") {
          if (newData["HSC_FOLLOW_UP"]) {
              const followUpList = newData["HSC_FOLLOW_UP"].split(",");
              if (!followUpList.includes(loggedInUserEmail)) {
                  followUpList.push(loggedInUserEmail);
              }
              newData["HSC_FOLLOW_UP"] = followUpList.join(",");
          } else {
              newData["HSC_FOLLOW_UP"] = loggedInUserEmail;
          }

          delete newData["HSC_HOT_LIST"];
      } 
      else if (newData["HSC_HOT_LIST"] === "0") {
          if (newData["HSC_FOLLOW_UP"]) {
            let followUpList = newData["HSC_FOLLOW_UP"]
                                    .split(",")
                                    .map(email => email.trim())
                                    .filter(email => email !== loggedInUserEmail);

              //let followUpList = newData["HSC_FOLLOW_UP"].split(",");
              //followUpList = followUpList.filter(email => email !== loggedInUserEmail); 
              newData["HSC_FOLLOW_UP"] = followUpList.length > 0 ? followUpList.join(",") : ""; 
          }
          delete newData["HSC_HOT_LIST"];
      }
  
      this.setState({
          isBusy: true,
          error: null,
          success: null,
      });
  
      const original = this.state.original || {};
      // Delete and Undelete stay on Arc; an add makes the Kore lead first, and an edit is carried on to it.
      const isEdit = Boolean(newData.ARCIMEDES_ROW_ID)
          && (newData.DELETED || null) === (original.DELETED || null);
      const savePromise = !this.props.edit
          ? createAgent(newData, { force }).then((agent) => ({ success: true, data: [agent] }))
          : isEdit
              ? updateAgent(newData.ARCIMEDES_ROW_ID, newData).then((agent) => ({ success: true, data: [agent], saved: agent }))
              : manageData({ tableCode: AGENTS, data: [newData] });

      return savePromise.then((res) => {
          if (res && res.success) {
              const saved = res.saved ? withHotList(res.saved, this.state.loggedInUserData.email) : null;

              this.setState(
                  (prevState) => ({
                      isBusy: false,
                      success: "Saved",
                      duplicates: null,
                      // What the next save is compared with: an Undelete right
                      // after a Delete has to read as one, not as an edit.
                      ...(saved ? { data: saved, original: { ...saved } } : { original: { ...prevState.data } }),
                  }),
                  () => {
                      if (!this.props.edit) {
                          browserHistory.push({
                              pathname: `/agent/${res.data[0].ARCIMEDES_ROW_ID}`,
                          });
                      }
                  }
              );
  
              window.scrollTo(0, 0);
          } else {
              this.setState({
                  isBusy: false,  // Fix: should not be null
                  error: res && res.message ? res.message : "Unspecified error",
              });
          }
      }).catch((err) => {
          if (err && err.code === DUPLICATE_AGENT) {
              this.setState({
                  isBusy: false,
                  viewMode: false,
                  duplicates: err.data || [],
                  duplicateMessage: err.message,
              });
              return;
          }

          this.setState({
              isBusy: false,
              viewMode: false,
              error: err && err.message ? err.message : "Unspecified error",
          });
      });
  }
  
  /* saveData() {
    if (this.state.isBusy) return;
    if(this.state.data['HSC_HOT_LIST'] && this.state.data['HSC_HOT_LIST']==='1'){
      
      delete this.state.data['HSC_HOT_LIST'];
    }
    this.setState({
      isBusy: true,
      error: null,
      success: null,
    });

    return manageData({ tableCode: AGENTS, data: [this.state.data] }).then(
      (res) => {
        if (res && res.success) {
          this.setState(
            {
              isBusy: false,
              success: "Saved",
            },
            () => {
              if (!this.props.edit) {
                browserHistory.push({
                  pathname: `/agent/${res.data[0].ARCIMEDES_ROW_ID}`,
                });
              }
            }
          );

          window.scrollTo(0, 0);
        } else {
          this.setState({
            isBusy: null,
            error: res && res.message ? res.message : "Unspecified error",
          });
        }
      }
    );
  } */

  handleChangeDropdown(query, queryType, x, key) {
    this.setState({
      data: Object.assign(this.state.data, {
        [key]: query[key],
      }),
    });
  }

  formatHscMembers (){
      if(Array.isArray(this.state.hscAgentsData) && this.state.hscAgentsData.length){
        return this.state.hscAgentsData.map((agent) => {
          return {
            NAME: `${agent.FIRST_NAME} ${agent.LAST_NAME}`,
            HSC_FOLLOW_UP:agent.ARCIMEDES_ROW_ID,
          };
        });
      }
      return []
  }

  render() {
    const data = this.state.data;
    const { edit } = this.props;

    return (
      <React.Fragment>
      <CRUD
        tabsData={[
          {
            name: "AGENT",
            renderedComponent: (
              <AgentInfo
                data={data}
                handleChangeInput={this.handleChangeInput}
                handleChangeDropdown={this.handleChangeDropdown}
                viewMode={this.state.viewMode}
                deleted={data && data.DELETED === "1"}
                hscAgentsData ={this.state.hscAgentsData}
                hscOptions ={this.formatHscMembers()}
              />
            ),
          },
          {
            name: "FIRM",
            renderedComponent: (
              <LinkedFirm
                firm={this.state.firm}
                viewMode={this.state.viewMode}
                deleted={data && data.DELETED === "1"}
                onChange={this.firmEdits.change}
              />
            ),
          },
        ]}
        backLink={`${arc.path.base}agents`}
        edit={edit}
        state={this.state}
        setState={this.setState.bind(this)}
        handleSubmit={this.handleSubmit}
        saveData={this.saveData}
        onCancel={this.firmEdits.discard}
        type="agent"
        backName="AGENTS"
        title={data && `${data.FIRST_NAME} ${data.LAST_NAME}`}
        /* Edit and Delete for whoever edits every SUMMIT record (the old admin rule). */
        forceActions={editsEverySummitRecord(getCurrentAccess())}
      />
      {/* Out of the page's form, which its buttons would otherwise submit. */}
      {ReactDOM.createPortal(
        <AgentDuplicateModal
          show={Boolean(this.state.duplicates)}
          message={this.state.duplicateMessage}
          agents={this.state.duplicates || []}
          busy={Boolean(this.state.isBusy)}
          error={this.state.duplicates ? this.state.error : null}
          onBack={() => this.setState({ duplicates: null, error: null })}
          onAddAnyway={() => this.saveAgent(true)}
        />,
        document.body,
      )}
      </React.Fragment>
    );
  }
}
